module.exports = __webpack_public_path__ + "static/media/service-1.a81e2c2a.jpg";